const c = ["#f3ddcc", "#e6a07c", "#d46f4f", "#741009"], d = ["#f3ddcc", "#edb694", "#df8963", "#c8553a", "#741009"], f = [
  "#faf3ed",
  "#f3ddcc",
  "#edb694",
  "#df8963",
  "#c8553a",
  "#741009"
];
export {
  c as DEMOGRAPHICS_PEACH_4,
  d as DEMOGRAPHICS_PEACH_5,
  f as DEMOGRAPHICS_PEACH_6
};
//# sourceMappingURL=index.es5597.js.map
